import { Button, CircularProgress } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

export function useInstitutions() {
  const [institutions, setInstitutions] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/institutions')
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        setInstitutions(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { institutions, setInstitutions, isLoading };
}
export default function Institutions() {
  const { institutions, setInstitutions, isLoading } = useInstitutions();
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/institutions-update/${id}`);
  };

  const columns = [
    {
      name: 'NIT',
      label: 'NIT',
    },
    {
      name: 'name',
      label: 'Nombre',
    },
    {
      name: 'fixedPhone',
      label: 'Teléfono',
      options: {
        filter: false,
      },
    },
    {
      name: 'state',
      label: 'Estado',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(institutions[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar las instituciones seleccionadas?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/institutions/${
            institutions[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
          }
        );
        let data = await response.json();
        if (data.success) {
          setInstitutions(institutions.splice(row?.dataIndex, 1));
        }
      });
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar la lista de
        instituciones activas en la plataforma, podrás utilizar nuestras
        herramientas como filtros, descargar, impresión entre otras
        funcionalidades, recuerda que si utilizar la opción de Borrar, esto no
        se puede recuperar y los usuarios que pertenezcan a la institución
        eliminada, quedarán sin colegio asignado.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Listado de instituciones'}
          data={institutions}
          columns={columns}
          options={{
            filter: 'dropdown',
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress />
      )}
    </div>
  );
}
